// Portrait d'un membre : photo pour Élise, initiale stylisée pour le reste de l'équipe.
export const TeamPortrait = ({ member, className = "" }) =>
  member.photo ? (
    <img
      src={member.photo}
      alt={`${member.prenom} — ${member.role} chez Demoiselle Atypique`}
      className={`h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04] ${className}`}
    />
  ) : (
    <div
      className={`relative flex h-full w-full items-center justify-center border border-white/10 bg-[#251A33] ${className}`}
      data-testid={`team-initial-${member.id}`}
      aria-label={`${member.prenom} — ${member.role}`}
    >
      <span className="font-display text-[26vw] leading-none text-neon/70 transition-colors duration-500 group-hover:text-neon sm:text-[88px] lg:text-[110px]">
        {member.prenom[0]}
      </span>
      <span className="absolute bottom-4 left-4 font-mono text-[9px] uppercase tracking-[0.25em] text-white/30">{member.role}</span>
    </div>
  );
